import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import storeData from '../data/storeData.json';
import '../style/RedirectPage.css';

const RedirectPage = () => {
  const { storeSlug, couponIndex } = useParams();
  const navigate = useNavigate();
  const store = storeData[storeSlug];
  const coupon = store?.coupons[couponIndex];

  useEffect(() => {
    if (coupon?.url) {
      const timer = setTimeout(() => {
        window.location.href = coupon.url; // Redirect to store
      }, 2000); // Delay before redirect
      return () => clearTimeout(timer);
    } else {
      navigate(`/store/${storeSlug}`);
    }
  }, [coupon, navigate, storeSlug]);

  if (!coupon) {
    return <h1>Invalid Coupon</h1>;
  }

  return (
    <div className="redirect-page">
      <h2>No code required</h2>
      <p>Carry on shopping as usual</p>
      <button className="offer-btn">OFFER ACTIVATED</button>
      <p>Opening {store.title}...</p>
    </div>
  );
};

export default RedirectPage;
